import React from 'react';
import {Link} from 'react-router-dom';

import AdminLayout from 'Pages/Admin/AdminLayout';
import {Toggle, FormHandler, Textarea} from 'Components/Form';
import {Loading, Alert} from 'Components/Partials';
import {PrimaryButton, SecondaryButton} from 'Components/Button';

import {Toast} from 'Services';
import Question from 'Services/Api/Admin/MainStage/Question';

class Store extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Question has been submitted successfully';

    /**
     * @var state
     */
    state = {
        loading: false,
        question_id: this.props.match?.params?.question ?? '',
        session_id: this.props.match?.params?.session ?? '',
    };

    /**
     * @method componentDidMount
     */
    async componentDidMount() {
        if (this.state.question_id) {
            await this.fetchQuestion();
        } else {
            this.props.setForm({
                stream_src: 'primary',
            });
        }
    };

    /**
     * @method fetchQuestion
     * @return {Promise<void>}
     */
    fetchQuestion = async () => {
        this.setState({
            loading: true,
        });

        const request = await Question.get({
            session: this.state.session_id,
            question_id: this.state.question_id,
        });

        if (request.success) {
            const s = request.data.data;

            this.props.setInitialValues({
                ...s,
            });

            return this.setState({
                loading: false,
            });
        }

        return Toast.error();
    };

    /**
     * @method handleSubmit
     * @param {object} form
     * @return {Promise<boolean|{status: number}>|Promise<AxiosResponse<any>>|*}
     */
    handleSubmit = (form) => {
        if (this.state.question_id) {
            return Question.patch({
                session: this.state.session_id,
                question: this.state.question_id,
            }, form);
        } else {
            return Question.post(null, form);
        }
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {
            handleInput,
            getFieldError,
            handleSubmit,
            alert,
            working,
            form,
        } = this.props;

        const {
            loading,
            question_id,
        } = this.state;

        return (
            <AdminLayout title={'Main Stage - ' + (question_id ? 'Update' : 'Create') + ' Question'}>
                {loading && (
                    <div className="p-6">
                        <Loading/>
                    </div>
                )}

                {!loading && (
                    <form 
                        onSubmit={(e) => handleSubmit(e, this.handleSubmit, this.success, !question_id)}
                        className="divide-y divide-gray-200 lg:col-span-9"
                    >
                        <div className="p-6">
                            {alert && (<Alert {...alert} />)}

                            <Textarea
                                containerClassName="mb-4"
                                label="Question"
                                value={form.question}
                                error={getFieldError('question')}
                                onChange={(v) => handleInput('question', v)}
                            />

                            <Toggle
                                value={form.approved}
                                error={getFieldError('approved')}
                                onChange={(v) => handleInput('approved', v)}
                                label="Approved"
                            />
                        </div>

                        <div className="p-6 flex justify-between">
                            <Link to="/admin/main-stage/questions">
                                <SecondaryButton text="Back" onClick={() => null} />
                            </Link>

                            <PrimaryButton working={working} text="Save" />
                        </div>
                    </form>
                )}
            </AdminLayout>
        );
    }
}

export default FormHandler(Store);
